var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Customer"}},[_c('Customer')],1),_c('vs-tab',{attrs:{"label":"Distribution Channel"}},[_c('DistributionChannel')],1),_c('vs-tab',{attrs:{"label":"Distribution Channel SKU"}},[_c('DistributionChannelSKU')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }